import { useState, useEffect } from 'react';

interface User {
  id: number;
  email: string;
  name: string;
  role: string;
}

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simple check: if accessToken exists, user is authenticated
    const accessToken = localStorage.getItem('accessToken');
    setIsAuthenticated(!!accessToken);

    // Try to load user data if exists (optional)
    if (accessToken) {
      const savedUser = localStorage.getItem('user');
      if (savedUser) {
        try {
          setUser(JSON.parse(savedUser));
        } catch {
          // Ignore bad user payload but keep the token intact
        }
      }
    }

    setIsLoading(false);
  }, []);

  const login = (_accessToken: string, userData?: User) => {
    // Token is already stored by caller, just sync state
    setIsAuthenticated(true);
    if (userData) {
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
    }
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
  };
}
